import Swiper from "swiper/bundle";

if (document.querySelectorAll(".extended-cards-swiper")) {
  document.querySelectorAll(".extended-cards-swiper").forEach((el) => {
    const nextEl = el.querySelector(".swiper-button-next");
    const prevEl = el.querySelector(".swiper-button-prev");
    const paginationEl = el.querySelector(".swiper-pagination");
    const swiper = new Swiper(el, {
      // Optional parameters
      A11y: true,
      loop: true,
      autoplay: {
        delay: 5000,
      },
      slidesPerView: 1,
      spaceBetween: 24,
      breakpoints: {
        992: {
          slidesPerView: 3,
        },
      },

      on: {
        afterInit: extendedCards(),
      },

      // If we need pagination
      pagination: {
        el: paginationEl,
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },

      // And if we need scrollbar
      scrollbar: {
        el: ".swiper-scrollbar",
      },
    });
  });
}

function extendedCards() {
  if (document.getElementsByClassName("extended-cards")) {
    answers();
    const buttons = document.querySelectorAll(".show-icon-button");

    buttons.forEach((button) => {
      button.addEventListener("click", function () {
        console.log("click");
        const targetSelector = this.dataset.target;
        const parent = this.closest(".extended-card-inner");
        const allParents = document.querySelectorAll(".extended-card-inner");
        const targetElement = this.closest(
          ".extended-card-inner"
        ).querySelector(targetSelector); // Target within the same card

        // Hide all other visible hidden texts
        document.querySelectorAll(".hidden-text").forEach((el) => {
          if (el !== targetElement && el.style.opacity === "1") {
            el.style.opacity = "0";
            el.style.height = "0";
            el.style.marginTop = "0";
            allParents.forEach((p) => {
              p.style.backgroundColor = "#f5f5f5";
            });
            // allParents.forEach().style.backgroundColor = "#f5f5f5";
          }
        });

        // Toggle the target element
        if (targetElement.style.opacity === "1") {
          targetElement.style.opacity = "0";
          targetElement.style.height = "0";
          targetElement.style.marginTop = "0";
          parent.style.backgroundColor = "#f5f5f5";
        } else {
          targetElement.style.opacity = "1";
          targetElement.style.height = "auto";
          targetElement.style.marginTop = "1rem";
          parent.style.backgroundColor = "#fff";
        }
      });
    });
  }
}

function answers() {
  const answers = document.querySelectorAll(".hidden-text");
  answers.forEach(function (answer) {
    answer.style.opacity = "0";
    answer.style.height = "0";
    answer.style.marginTop = "0";
  });
}
